import { render } from "./propertySlider.vue?vue&type=template&id=d7134f10&scoped=true"
import script from "./propertySlider.vue?vue&type=script&lang=js"
export * from "./propertySlider.vue?vue&type=script&lang=js"

import "./propertySlider.vue?vue&type=style&index=0&id=d7134f10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7134f10"]])

export default __exports__